import Certificate from "../../components/Сertificate/Certificate"
export default function СertificatePage() {
    return <Certificate/>
}